<template>
    <div class="window-wrapper" v-show="visible">
        <div class="window change-password-window" v-show="visible">
            <div class="window-head">
                <div class="title">Изменить пароль
                    <span class="close"
                          @click="closeWindow"><img src="@/image/close.png"></span>
                </div>
            </div>
            <div class="window-body">
                <div class="form">
                    <fieldset>
                        <input type="password"
                               autocomplete="off"
                               v-model="password"/>
                        <label>Новый пароль *</label>
                    </fieldset>
                    <fieldset>
                        <input type="password"
                               autocomplete="off"
                               v-model="repeatPassword"/>
                        <label>Повторите пароль *</label>
                    </fieldset>
                    <div class="error" v-show="!passwordsMatch">
                        <i class="fa fa-exclamation-circle"></i>Пароли не совпадают
                    </div>
                    <div class="error" v-show="passwordsMatch && errorMessage">
                        <i class="fa fa-exclamation-circle"></i>{{ errorMessage }}
                    </div>
                    <div class="center">
                        <button class="button blue-button" type="button"
                                :disabled="!inputDataValid"
                                @click="sendChangePasswordRequest">Изменить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utils from '@/utils';

    export default {
        name: "ChangePasswordWindow",

        props: ['visible'],

        data() {
            return {
                password: '',
                repeatPassword: '',
                errorMessage: ''
            }
        },

        watch: {
            visible(val) {
                if (!val) {
                    this.password = '';
                    this.repeatPassword = '';
                    this.errorMessage = '';
                }

                utils.changePopupWindowVisibility(val);
            },

            password(val) {
                this.errorMessage = false;
            },

            repeatPassword(val) {
                this.errorMessage = false;
            }
        },

        computed: {
            passwordsMatch() {
                return this.password.length == 0
                        || this.repeatPassword.length == 0
                        || this.password === this.repeatPassword;
            },

            inputDataValid() {
                return this.passwordsMatch
                        && this.password.length > 0
                        && this.repeatPassword.length > 0;
            }
        },

        methods: {
            async sendChangePasswordRequest() {
                if (!this.inputDataValid)
                    return;

                try {
                    await this.$store.dispatch('setNewPassword', this.password);
                    alert('Пароль был изменён!');
                    this.closeWindow();
                } catch (error) {
                    this.errorMessage = error.response.data.message;
                }
            },

            closeWindow() {
                this.$emit('close-window');
            }
        },

        destroyed() {
            utils.changePopupWindowVisibility(false);
        }
    }
</script>